import React, { Suspense } from "react";
import BackdropSpinner from "../../../shared/backdrop-spinner/BackdropSpinner";
import ErrorBoundary from "../../../shared/error-boundary/ErrorBoundary";
import { Helmet } from "react-helmet";

interface Props {
    Component: React.FunctionComponent;
    Layout: React.ComponentType<any>;
    title?: string;
}

const RouteWrapper = ({ Component, Layout, title }: Props) => {
    return (
        <>
            {title && (
                <Helmet>
                    <title>{title} | Genie</title>
                </Helmet>
            )}
            <Layout>
                <ErrorBoundary>
                    <Suspense fallback={<BackdropSpinner />}>
                        <Component />
                    </Suspense>
                </ErrorBoundary>
            </Layout>
        </>
    );
};

export default RouteWrapper;
